<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <app-input-text
      (change)="onInput()"
      (input)="onInput()"
      (blur)="onInput()"
      [control]="form.get('reference')"
      [placeholder]="'subscription_reference_placeholder' | i18next: {code: referencePlaceholder}"
      name="subscription_reference"
    ></app-input-text>
  </div>

  <div class="d-flex justify-content-end mt-5">
    <ng-content></ng-content>
    @if (submitForm) {
      <app-button-submit
        [invalid]="form.invalid"
        [label]="submitLabel"
      ></app-button-submit>
    }
  </div>
</form>
